import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

/**
 * @param {Object} props
 * @param {string} [props.id]
 * @param {import('utils/types').FlexDirection} [props.direction]
 * @param {'stretch' | 'flex-start' | "center" | 'flex-end'} [props.align]
 * @param {'flex-start' | "center" | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly' } [props.justify]
 * @param {import('utils/types').Space} [props.gap] number of pixels between children
 * @param {string} [props.className]
 * @param {React.ReactNode} [props.children]
 */
export default function Flex({
  id = undefined,
  direction = 'row',
  align = 'stretch',
  justify = 'flex-start',
  gap = 0,
  className = '',
  children = null,
  ...htmlProps
}) {
  return (
    <div
      id={id}
      data-direction={direction}
      className={cn(styles.container, className)}
      style={{
        gap: `${gap}px`,
        alignItems: align,
        justifyContent: justify
      }}
      {...htmlProps}
    >
      {children}
    </div>
  );
}
